import React from 'react'
import { Form } from 'antd'

class FormContent extends React.Component {
  render() {
    const { form, children } = this.props
    const { getFieldDecorator, getFieldValue } = form
    return <Form>{children(getFieldDecorator, getFieldValue)}</Form>
  }
}

const WrappedForm = Form.create({ name: 'wrappedForm' })(FormContent)
export default WrappedForm
